import * as React from 'react';

import HFNCTherapy from './HFNCTherapy';
import MADTherapy from './MandibularAdvancementDevice';
import OtherTreatment from './OtherTreatment';
import OxygenTherapy from './OxygenTherapy';
import PAPTherapy from './PAPTherapy';
import PatientDoesNotWantRespiratorySupportTherapy from './PatientDoesNotWantRespiratorySupportTherapy';
import SurgicalTreatment from './SurgicalTreatment';
import { TDocument } from '../definitions';

const TreatmentForm = ({ document }: IOwnProps): React.JSX.Element | null =>
  document._type === 'papTherapy' ? (
    <PAPTherapy />
  ) : document._type === 'hfncTherapy' ? (
    <HFNCTherapy />
  ) : document._type === 'oxygenTherapy' ? (
    <OxygenTherapy />
  ) : document._type === 'madTherapy' ? (
    <MADTherapy />
  ) : document._type === 'surgicalTreatment' ? (
    <SurgicalTreatment />
  ) : document._type === 'otherTreatment' ? (
    <OtherTreatment />
  ) : document._type === 'patientDoesNotWantRespiratorySupportTherapy' ? (
    <PatientDoesNotWantRespiratorySupportTherapy />
  ) : null;

interface IOwnProps {
  document: TDocument;
}

export default TreatmentForm;
